import { ValueFormatterParams } from '@ag-grid-community/core'
import { Component, Input } from '@angular/core'
import { titleCaseFormatter } from '@helios/ag-grid-config'
import { Command } from '../models/command.model'

@Component({
  selector: 'hs-command-card',
  templateUrl: './command-card.component.html',
  styleUrls: ['./command-card.component.scss'],
})
export class CommandCardComponent {
  private _command?: Command

  get command(): Command | undefined {
    return this._command
  }

  @Input() set command(value: Command | undefined) {
    // No work to do
    if (!value?.command) {
      return
    }

    this._command = value
    this.title = titleCaseFormatter({
      value: value.command.commandType,
    } as ValueFormatterParams)

    this.notes = value.command.notes ?? ''
    this.created = value.createdTs ?? undefined
    this.accountId = value.command.accountId + ''
    this.needsReview = value.needsReview
  }

  title = ''
  notes = ''
  accountId?: string
  isSummary = true
  created: string | Date | undefined = ''
  needsReview = false

  toggleSummary() {
    this.isSummary = !this.isSummary
  }
}
